import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export type ResponseType = {}

type AnalysisUpdateData = {
  plantId: string
  externalGroupId: string
  stoppageStart: string
  stoppageEnd: string
  analysisId: number
}

export const useLinkStoppage = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (analysisData: AnalysisUpdateData) => {
      const path = `/rootcausefailureanalysis/analyses/${analysisData.analysisId}/link/stoppage`

      return (
        await ApiClient.axiosInstance.post<ResponseType>(
          path,
          {
            plantId: analysisData.plantId,
            externalGroupId: analysisData.externalGroupId,
            stoppageStart: analysisData.stoppageStart,
            stoppageEnd: analysisData.stoppageEnd
          },
          {}
        )
      ).data
    },
    onSuccess: async (data: ResponseType) => {
      await queryClient.invalidateQueries({queryKey: ['graph-data']})
      await queryClient.invalidateQueries({queryKey: ['stoppages']})
      await queryClient.invalidateQueries({queryKey: ['analysis-list']})
      queryClient.removeQueries({queryKey: ['analysis-detail']})
      queryClient.removeQueries({queryKey: ['analysis-summary']})
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
      return data
    }
  })
}
